import { useEffect } from 'react';
import { useSettings } from '../context/SettingsContext';

const FaviconUpdater = () => {
  const { settings, loading } = useSettings();

  useEffect(() => {
    if (loading) return;

    // Mettre à jour le favicon
    const updateFavicon = (href) => {
      // Supprimer les anciens favicons
      const existingFavicons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
      existingFavicons.forEach(link => link.remove());

      // Créer le nouveau favicon
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = href;
      document.head.appendChild(link);
    };

    // Mettre à jour l'apple-touch-icon
    const updateAppleTouchIcon = (href, sizes = null) => {
      // Supprimer les anciens apple-touch-icon
      const existingAppleIcons = document.querySelectorAll('link[rel="apple-touch-icon"]');
      existingAppleIcons.forEach(link => link.remove());

      // Créer le nouveau apple-touch-icon
      const link = document.createElement('link');
      link.rel = 'apple-touch-icon';
      link.href = href;
      if (sizes) {
        link.setAttribute('sizes', sizes);
      }
      document.head.appendChild(link);
    };

    // Mettre à jour les icônes PWA (logo192 et logo512)
    const updatePWAIcons = (href) => {
      // Supprimer les anciennes icônes PWA
      const existingPWAIcons = document.querySelectorAll('link[rel="icon"][sizes]');
      existingPWAIcons.forEach(link => {
        const sizes = link.getAttribute('sizes');
        if (sizes && (sizes.includes('192') || sizes.includes('512'))) {
          link.remove();
        }
      });

      // Créer les nouvelles icônes PWA
      [192, 512].forEach(size => {
        const link = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.sizes = `${size}x${size}`;
        link.href = href;
        document.head.appendChild(link);
      });
    };

    // Mettre à jour le manifest.json dynamiquement
    const updateManifest = (iconUrl, siteName) => {
      const manifestLink = document.querySelector('link[rel="manifest"]');
      if (manifestLink) {
        // Créer un manifest dynamique
        const manifest = {
          short_name: siteName || 'Tchamba Market',
          name: siteName || 'Tchamba Marketplace',
          description: settings?.site_description || 'Plateforme d\'achat et de vente locale à Tchamba',
          icons: [
            {
              src: iconUrl || `${process.env.PUBLIC_URL}/logo.png`,
              type: 'image/png',
              sizes: '192x192',
              purpose: 'any maskable'
            },
            {
              src: iconUrl || `${process.env.PUBLIC_URL}/logo.png`,
              type: 'image/png',
              sizes: '512x512',
              purpose: 'any maskable'
            }
          ],
          start_url: '.',
          display: 'standalone',
          orientation: 'portrait-primary',
          theme_color: '#f97316',
          background_color: '#ffffff',
          scope: '/',
          categories: ['shopping', 'marketplace', 'business']
        };

        // Créer un blob URL pour le manifest
        const blob = new Blob([JSON.stringify(manifest, null, 2)], { type: 'application/json' });
        const manifestUrl = URL.createObjectURL(blob);
        
        // Mettre à jour le lien du manifest
        manifestLink.href = manifestUrl;
      }
    };

    // Mettre à jour le titre de la page
    const updateTitle = (siteName) => {
      if (siteName) {
        document.title = siteName;
      }
    };

    // Mettre à jour les meta tags pour le splash screen
    const updateMetaTags = (siteName) => {
      // Mettre à jour apple-mobile-web-app-title
      let appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
      if (!appleTitle) {
        appleTitle = document.createElement('meta');
        appleTitle.setAttribute('name', 'apple-mobile-web-app-title');
        document.head.appendChild(appleTitle);
      }
      appleTitle.setAttribute('content', siteName || 'Tchamba Market');
    };

    // Utiliser logo.png du dossier public
    const logoUrl = `${process.env.PUBLIC_URL}/logo.png`;
    const siteName = settings?.site_name || 'Tchamba Marketplace';

    // Mettre à jour toutes les icônes avec logo.png
    updateFavicon(logoUrl);
    updateAppleTouchIcon(logoUrl, '192x192');
    updateAppleTouchIcon(logoUrl, '512x512');
    updatePWAIcons(logoUrl);
    updateManifest(logoUrl, siteName);

    // Mettre à jour le titre et les meta tags
    updateTitle(siteName);
    updateMetaTags(siteName);
  }, [settings, loading]);

  return null;
};

export default FaviconUpdater;

